import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import actionTypes from 'constants/actionTypes';
import { useAddHoldingClassModal } from '../context/AddHoldingClassModalContext';

const AddHoldingClassModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAddHoldingClassModal();

  const isValisData = data.name && data.selectedNumerationClass;
  const isEdited =
    data.modalActionType === actionTypes.EDIT ? data.hasBeenEdited : true;

  const buttonDisabled = !isValisData || !isEdited || data.isLoading;

  const buttonLabel =
    data.modalActionType === actionTypes.EDIT
      ? t('UpdateClass')
      : t('AddClass');

  const isReadOnlyView = data.modalActionType === actionTypes.VIEW;

  return (
    <>
      {!isReadOnlyView && (
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-lg btn-primary"
            onClick={actions.handleSaveHoldingClass}
            disabled={buttonDisabled}
          >
            {buttonLabel}
          </button>
        </Modal.Footer>
      )}
    </>
  );
};

export default AddHoldingClassModalFooter;
